
    <div style="height: 100%" [class]="'modal-dialog' + (config.class ? ' ' + config.class : '')" role="document">
      <div style="height: 100%" class="modal-content">
        <ng-content></ng-content>
      </div>
    </div>
  